"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityList = void 0;
const TOP_LIST_ITEMS = 4;
class ActivityList extends Array {
    constructor(...items) {
        super(...items);
        this.getSortedList = () => {
            const items = [
                ...this.getOrderByCustomOrder(...this.getFeatured().getWithCustomOrder()),
                ...this.getNewestFirst(...this.getFeatured().getWithoutCustomOrder()),
                ...this.getOrderByCustomOrder(...this.getNonFeatured().getWithCustomOrder()),
                ...this.getNewestFirst(...this.getNonFeatured().getWithoutCustomOrder())
            ];
            return new ActivityList(...items);
        };
        this.getFeatured = () => new ActivityList(...this.filter(x => x.isFeatured));
        this.getNonFeatured = () => new ActivityList(...this.filter(x => !x.isFeatured));
        this.getWithCustomOrder = () => new ActivityList(...this.filter(x => x.customOrder > 0));
        this.getWithoutCustomOrder = () => new ActivityList(...this.filter(x => x.customOrder < 1));
        this.getOrderByCustomOrder = (...items) => new ActivityList(...items.sort((x, y) => (x.customOrder > y.customOrder ? -1 : 1)));
        this.getNewestFirst = (...items) => new ActivityList(...items.sort((x, y) => {
            const dateStartX = !!x.date_start ? x.date_start : 0;
            const dateStartY = !!y.date_start ? y.date_start : 0;
            return dateStartX > dateStartY ? -1 : 1;
        }));
        this.getDateStartSorted = () => this.sort((x, y) => {
            const dateStartX = !!x.date_start ? x.date_start : 0;
            const dateStartY = !!y.date_start ? y.date_start : 0;
            return dateStartX > dateStartY ? -1 : 1;
        });
        this.isFeatured = () => this.find(x => x.isFeatured);
        this.getActivitiesListSorted = () => {
            const activityList = new ActivityList();
            if (this.length > 0) {
                this.filter(x => x.isFeatured)
                    .slice(1)
                    .forEach(x => activityList.push(x));
                this.filter(x => !x.isFeatured).forEach(x => activityList.push(x));
            }
            return activityList;
        };
        this.isScanTicket = () => {
            const activityList = new ActivityList();
            this.filter(x => x.isScanTicket).forEach(x => activityList.push(x));
            return activityList;
        };
        this.topSection = () => {
            const activityList = new ActivityList();
            const thisFeaturedActivity = this.isFeatured();
            this.filter(x => !x.isScanTicket &&
                !x.isMobileAppSignInBonus &&
                !x.isWebOnly &&
                (!thisFeaturedActivity || thisFeaturedActivity.id !== x.id))
                .filter((_x, index) => index < TOP_LIST_ITEMS)
                .forEach(x => activityList.push(x));
            return activityList;
        };
        this.bottomSection = () => {
            const activityList = new ActivityList();
            const thisFeaturedActivity = this.isFeatured();
            this.filter(x => !x.isScanTicket &&
                !x.isMobileAppSignInBonus &&
                !x.isWebOnly &&
                (!thisFeaturedActivity || thisFeaturedActivity.id !== x.id))
                .filter((_x, index) => index >= TOP_LIST_ITEMS)
                .forEach(x => activityList.push(x));
            return activityList;
        };
        this.getMobileList = () => new ActivityList(...this.filter(x => x.isVisibleOnMobileListPage)).getSortedList();
        this.getWebList = () => new ActivityList(...this.filter(x => x.isVisibleOnWebListPage)).getSortedList();
    }
}
exports.ActivityList = ActivityList;
ActivityList.getCombinedSortedList = (activityList, other = []) => {
    const combinedList = [...activityList, ...other];
    const list = Array.from(new Set(combinedList.map(x => x.id)))
        .map(activityId => combinedList.find(x => x.id === activityId))
        .filter(x => !!x);
    return new ActivityList(...list).getSortedList();
};
//# sourceMappingURL=ActivityList.js.map